export { default as CommentsEndpoint } from './CommentsEndpoint'
export { default as NewsService } from './NewsService'
export { default as PostDocument } from './PostDocument'
export { default as PostsEndpoint } from './PostsEndpoint'

export * from './NewsService'